"use client";

import { usePathname } from "next/navigation";

import { NotebookRouteEntryTracker } from "@/lib/notebook/core/NotebookRouteEntryTracker";

/** Notebook DOM purge logic only on notebook routes — not marketing/settings/billing. */
export function NotebookRouteTracker() {
  const pathname = usePathname();
  if (!pathname?.startsWith("/notebook")) return null;
  return <NotebookRouteEntryTracker />;
}
